import axios from 'axios';

/*const headers = {
  'Authorization': localStorage.getItem('token') || '',
}*/

export default class MedidasService {

  constructor(){
    this.api_url = 'https://login.healthfy.com.br/api';
    //this.api_url = 'http://localhost:8000/api';
  }

  getMedidas(empresa_id){
    return axios.get(`${this.api_url}/medidas/empresa/${empresa_id}`);
  }

}



// WEBPACK FOOTER //
// ./src/services/MedidasService.js